import React, {useContext} from "react";
import {Form, Radio, Row, Col} from "antd";
import {Title} from "./Common";
import MapPropsContext from "../MapPropsContext";
import Seperator from "./Seperator";
import {chunksForArray} from "../../../utils";
import CheckboxGroupWithCheckAll from "./CheckboxGroupWithCheckAll";

// 톤수
const OPTIONS_TON = [
  {ton_code: "01", label: "2톤 미만"},
  {ton_code: "02", label: "2~5톤 이하"},
  {ton_code: "03", label: "5~40톤 이하"},
  {ton_code: "04", label: "40~100톤 이하"},
  {ton_code: "05", label: "100톤 초과"},
];

// 항해구역
const OPTIONS_INF = [
  {inf_code: "01", label: "연해"},
  {inf_code: "02", label: "근해"},
  {inf_code: "03", label: "평수지역"},
  {inf_code: "04", label: "원양"},
  {inf_code: "05", label: "기타"},
];

// 선종
const OPTIONS_DIV = [
  {div_code: "01", label: "어선"},
  {div_code: "02", label: "화물선"},
  {div_code: "03", label: "여객선"},
  {div_code: "04", label: "기타"},
];

// 지역정보 표시방법
const OPTIONS_DISPLAY = [
  {display_code: "01", label: "톤수별"},
  {display_code: "02", label: "항해구역별"},
  {display_code: "03", label: "선종별"},
];

function WidgetShipStats() {
  const {widgetState, onChangeWidgetState} = useContext(MapPropsContext);
  const { display_code_stats} = widgetState;

  return (
    <Form.Item>
      <CheckboxGroupWithCheckAll
        title="톤수"
        fieldName={"ton_code_stats_list"}
        options={OPTIONS_TON.map(({ ton_code, label }) => ({
          value: ton_code,
          label,
        }))}
        colSpan={12} />

      <Seperator/>

      <CheckboxGroupWithCheckAll
        title="항해구역"
        fieldName={"inf_code_stats_list"}
        options={OPTIONS_INF.map(({ inf_code, label }) => ({
          value: inf_code,
          label,
        }))}
        colSpan={8} />

      <Seperator/>

      <CheckboxGroupWithCheckAll
        title="선종"
        fieldName={"div_code_stats_list"}
        options={OPTIONS_DIV.map(({ div_code, label }) => ({
          value: div_code,
          label,
        }))}
        colSpan={8} />

      <Seperator/>

      <Title>지역정보 표시 방법 선택</Title>
      <Radio.Group name="display_code_stats"
                   value={display_code_stats}
                   style={{ width: '100%' }}
                   onChange={onChangeWidgetState}>
        {chunksForArray(OPTIONS_DISPLAY, 3).map((chunk, chunkIndex) =>
          <Row key={chunkIndex}>
            {chunk.map(({ display_code, label }) =>
              <Col span={8} key={display_code}>
                <Radio value={display_code}>{label}</Radio>
              </Col>
            )}
          </Row>
        )}
      </Radio.Group>
    </Form.Item>
  );
}

export default WidgetShipStats;
